export type PatientFlagValue = boolean | string | number;

export type PatientFlagMap = Record<string, PatientFlagValue>;

export type PatientFlagsInput = PatientFlagMap | string[];

export interface Patient {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  display_name: string;
  prompt?: string | null;
  system_prompt?: string | null;
  profile?: string | null;
  flags?: PatientFlagsInput;
  last_sign_in_at?: string | null;
  disabled_at?: string | null;
  status?: 'active' | 'invited' | 'disabled' | string;
}

export const normalizePatientFlags = (flags?: PatientFlagsInput): PatientFlagMap => {
  if (!flags) return {};
  if (Array.isArray(flags)) {
    return flags.reduce<PatientFlagMap>((acc, code) => {
      if (code) acc[code] = true;
      return acc;
    }, {} as PatientFlagMap);
  }
  return { ...flags };
};

const isTruthyFlag = (value: PatientFlagValue): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value !== 0;
  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return false;
  return normalized !== 'false' && normalized !== '0' && normalized !== 'no';
};

export const getActiveFlagEntries = (
  flags?: PatientFlagsInput,
): Array<[string, PatientFlagValue]> =>
  Object.entries(normalizePatientFlags(flags)).filter(([, value]) => isTruthyFlag(value));

export const patientFlagsToArray = (flags?: PatientFlagsInput): string[] =>
  getActiveFlagEntries(flags).map(([code]) => code);

export const togglePatientFlag = (
  flags: PatientFlagsInput,
  code: string,
  active: boolean,
): PatientFlagMap => {
  const map = normalizePatientFlags(flags);
  if (active) {
    map[code] = true;
  } else {
    delete map[code];
  }
  return map;
};
